import React, { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import {
  CloseButton,
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../components/Template/Modal'
import { ServicesModalWrapper } from '../../components/Calendar/ReservationModal'
import { is } from '../../components/MediaQuery'
import CursorPointer from '../../components/Template/CursorPointer/CursorPointer'
import { SquareCheckbox } from '../../components/FormBuilder'
import Button from '../../components/Template/Button'
import useSize from '../../hooks/useSize'
import { driver, names } from '../../database/localStorage'
import { Mixpanel } from '../../utils/Mixpanel'

function CloseModal({ open, close, closeModal, employee = false }) {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(false)
  const size = useSize()

  const isDesktop = is.desktop()

  useEffect(() => {
    if (open) {
      if (employee) {
        Mixpanel.track('Employees List Edit Abandoned Screen View', {
          'Employee ID': employee,
        })
      } else {
        Mixpanel.track('Employee List New Employee Abandoned Screen View', {})
      }
    }
  }, [open, employee])

  function onClose() {
    if (value) {
      driver.setItem(
        names.UserAccountStorage.DontShowAgainCloseModalEmployee,
        '1',
      )
    }
    close()
  }

  function onchange() {
    setValue(!value)
  }

  function warningMessage() {
    return t('exit_reservation_confirmation')
      .split('\\n')
      .map((mes, index) => <span key={index}>{mes}</span>)
  }

  function exit() {
    onClose()
    closeModal()
  }

  return (
    <ModalFlex
      style={{ marginBottom: isDesktop ? '30vh' : 0 }}
      open={open}
      onClose={onClose}
    >
      <ServicesModalWrapper>
        <ModalHeader
          style={{ padding: `${size}em ${0.4 * size}em 0px ${1.3 * size}em` }}
        >
          <Flex style={{ width: '100%' }} justifyStart={true}>
            <ModalHeaderLabel size={size}>
              {t('BBO_949_warning')}
            </ModalHeaderLabel>
          </Flex>
          <Flex style={{ width: '100% ' }} justifyEnd={true} alignCenter={true}>
            <CloseButton size={size} onClose={onClose} />
          </Flex>
        </ModalHeader>
        <Flex
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `${10 * size}px ${1.3 * size}em ${10 * size}px ${1.3 *
              size}em`,
          }}
        >
          {warningMessage()}

          <CursorPointer style={{ marginTop: `${1.5 * size}em` }}>
            <SquareCheckbox.Field
              size={size}
              fireEventOnClick={true}
              value={value}
              onChange={onchange}
              label={t('dont_show_again')}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />
          </CursorPointer>
        </Flex>
        <Flex
          row={true}
          style={{
            marginBottom: `${20 * size}px`,
            marginLeft: `${1.3 * size}em`,
            marginRight: `${1.3 * size}em`,
            marginTop: `${15 * size}px`,
          }}
        >
          <Button size={size} style={{ width: '100%' }} onClick={onClose}>
            <Trans i18nKey={'cancel'} />
          </Button>
          <Button
            size={size}
            style={{ width: '100%' }}
            onClick={exit}
            primary={true}
          >
            <Trans i18nKey={'exit'} />
          </Button>
        </Flex>
      </ServicesModalWrapper>
    </ModalFlex>
  )
}

export default CloseModal
